import {
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  ShowButton,
  EditButton,
  NumberField,
  BooleanField,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  ImageField,
} from "react-admin";

import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const GasBrandMerchantFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput source="gas_brand_id" reference="GasBrand" alwaysOn>
      <AutocompleteInput
        inputText={(record) => record.name}
        debounce={10}
        optionText="name"
        optionValue="id"
        filterToQuery={(searchText) => {
          const capitalized =
            searchText.charAt(0).toUpperCase() + searchText.slice(1);

          return { name: capitalized };
        }}
        suggestionLimit={10}
        alwaysOn
        resettable="true"
      />
    </ReferenceInput>
  </Filter>
);

const listGasBrandMerchant = (props) => {
  const t = useTranslate();
  const plugins = JSON.parse(localStorage.getItem("plugins"));

  return (
    <CustomList
      filters={<GasBrandMerchantFilter {...props} />}
      actions={<CreateOnlyTopToolbar />}
    >
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <ReferenceField source="logo_file_id" reference="File">
          <ImageField
            source="url"
            sx={{
              "& img": { maxWidth: 30, maxHeight: 30, objectFit: "contain" },
            }}
          />
        </ReferenceField>
        <ReferenceField source="gas_brand_id" reference="GasBrand">
          <TextField source="name" />
        </ReferenceField>
        {plugins && plugins.datexApiPayment && <TextField source="qr_type" />}
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.GasBrandMerchant.source.status.${record.status}`)
          }
        />
        {plugins.datexPayment && <NumberField source="priority" />}
        {plugins.datexPayment && (
          <BooleanField
            source="partner_gas_brand"
            sx={{
              "& .RaBooleanField-trueIcon": {
                color: "green",
              },
              "& .RaBooleanField-falseIcon": {
                color: "red",
              },
            }}
          />
        )}
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

export default listGasBrandMerchant;
